import React from "react";
import { formatNumber, percentageFormat } from "../../../../../Utils/utils";

interface ThirdCardRecalculateModalityProps {
  data: any;
  modalityData: any;
  selectedModality: any;
  hasModalityData: any;
}

const ThirdCardRecalculateModality = ({
  data,
  modalityData,
  selectedModality,
  hasModalityData,
}: ThirdCardRecalculateModalityProps) => {
  const findProductByMatch = () => {
    if (
      !data.producto ||
      !Array.isArray(data.producto) ||
      !data.modalidadGanada ||
      !data.modalidadGanada.datosModalidadGanada
    ) {
      return null;
    }

    const modalidadGanada = data.modalidadGanada.datosModalidadGanada;

    const matchedProduct = data.producto.find((producto: any) => {
      if (producto.modalidad !== modalidadGanada.modalidad) {
        return false;
      }

      const periodoGarantizado = parseInt(
        modalidadGanada.periodoGarantizado || "0"
      );
      const anosRT = parseInt(modalidadGanada.anosRT || "0");

      if (producto.periodoGarantizado !== periodoGarantizado) {
        return false;
      }
      if (producto.anosRT !== anosRT) {
        return false;
      }

      return true;
    });

    return matchedProduct;
  };

  const productMatch = data.estado === "ganado" ? findProductByMatch() : null;
  const respuestaMacro = productMatch && productMatch.respuestaMacro;

  return (
    <div className="card-verify ">
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Prima única AFP</div>
          <div className="card-verify__data">
            {hasModalityData &&
            (modalityData.primaAfp || modalityData.primaUnicaAFPEESS)
              ? formatNumber.new(
                  modalityData.primaAfp || modalityData.primaUnicaAFPEESS
                )
              : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Prima Única CIA:</div>
          <div className="card-verify__data">
            {hasModalityData &&
            (modalityData.primaCia || modalityData.primaUnicaEESS)
              ? formatNumber.new(
                  modalityData.primaCia || modalityData.primaUnicaEESS
                )
              : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Tipo de cambio</div>
          <div className="card-verify__data">
            {selectedModality.tipoCambio || data.tipoCambio || "--"}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Renta vitalicia</div>
          <div className="card-verify__data">
            {hasModalityData &&
            (modalityData.primaPensionRv || modalityData.primeraPensionRVD)
              ? formatNumber.new(
                  modalityData.primaPensionRv || modalityData.primeraPensionRVD
                )
              : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Renta temporal</div>
          <div className="card-verify__data">
            {hasModalityData &&
            (modalityData.primaPensionRt || modalityData.primeraPensionRT)
              ? formatNumber.new(
                  modalityData.primaPensionRt || modalityData.primeraPensionRT
                )
              : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Tasa venta</div>
          <div className="card-verify__data">
            {hasModalityData
              ? modalityData.tasaVenta ||
                modalityData.tasaInteresRVD ||
                modalityData.tasaInteresRT ||
                0
              : 0}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">TIR (%)</div>
          <div className="card-verify__data">
            {hasModalityData && modalityData.tir
              ? percentageFormat(modalityData.tir)
              : respuestaMacro && respuestaMacro.tir
                ? percentageFormat(respuestaMacro.tir)
                : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">VAN</div>
          <div className="card-verify__data">
            {hasModalityData && modalityData.van
              ? formatNumber.new(modalityData.van)
              : respuestaMacro && respuestaMacro.van
                ? formatNumber.new(respuestaMacro.van)
                : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Pérd. contable</div>
          <div className="card-verify__data">
            {hasModalityData && modalityData.perdida
              ? percentageFormat(modalityData.perdida)
              : respuestaMacro && respuestaMacro.perdida
                ? percentageFormat(respuestaMacro.perdida)
                : "--"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThirdCardRecalculateModality;
